var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deshboard"},[_c('div',{staticClass:"deshboard-cont"},[_c('div',{staticClass:"xs-index"},[_c('div',{staticClass:"xs-nav"},[_c('navigator')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }